import { RecordTypesHrm } from '../enums/audit-trail.enum';
import { OptionDescription } from '../types/option.type';
import { IAuditTrailAlignField } from "../interfaces";

export const generalFieldsHide = [
  'businessUnitId',
  'salesperson.id',
  'salespersonId',
  'companies.code',
  'companies.id',
  'schemeTypeId',
  'schemeType.id',
  'schemeType.code',
  'parentId',
  'parent.id',
  'parent.parent',
  'parent.parent.id',
  'user.roles.id',
  'user.roles.code',
  'recruiterId',
  'recruiter.id',
  'accumulateCommission',
  'idTypeId',
  'idType.id',
  'idType.code',
  'earliestManagerDate',
  'countryId',
  'country.id',
  'country.code',
  'maritalId',
  'marital.id',
  'marital.code',
  'nationality.id',
  'nationalityId',
  'nationality.code',
  'addressBackup',
  'appTypeIds',
  'bankId',
  'bank.code',
  'jobId',
  'createdBy',
  'updatedBy',
  'deletedBy',
  'parent.schemeType.code',
  'parent.schemeType.name',
  'commissionScheme.id',
  'commissionScheme.code',
  'leadership.id',
  'leadership.code',
  'appTypes.id',
  'appTypes.code',
  'qualification.id',
  'qualificationId',
  'qualification.code',
  'discipline.id',
  'disciplineId',
  'discipline.code',
  'highestQualification',
  'typeId',
  'informationType.id',
  'informationType.businessUnitId',
  'informationType.code',
  'manager.id',
  'emplacement.salesperson.id',
  'emplacement.manager.id',
  'company.id',
  'company.code',
  'address.postal',
  'address.building',
  'address.noOfRooms',
  'address.block',
  'address.state',
  'address.city',

  // perrsonal info verrifcation
  'oldValue.data',
  'oldValue.type',
  'newValue.data',
  'newValue.type',
  'reviewed.id',
  'reviewedBy',

  //hrm comm scheme
  'requiredTeamMember.commissionSchemeId',
  'group1.commId',
  'group1.comm.id',
  'group1.sequence',
  'group2.commId',
  'group2.comm.id',
  'group2.sequence',
  'requiredTeamMember.commissionScheme.id',
  'requiredCommissionScheme.commissionScheme.id',
  'splitMatrices.id',
  'splitMatrices.tiers.0.name',
  'splitMatrices.tiers.0.level',
  'splitMatrices.tiers.1.name',
  'splitMatrices.tiers.1.level',
  'splitMatrices.tiers.2.name',
  'splitMatrices.tiers.2.level',
  'splitMatrices.parties.0.name',
  'splitMatrices.parties.0.level',
  'leadershipDesignation.code',
  'leadershipDesignation.sequence',
];

export const fieldNameMapSalesperson: { [key: string]: string } = {
  'id': 'ID',
  'associatesCode': 'Associates Code',
  'user.username': 'Login ID',
  'isActive': 'Active',
  'businessName': 'Business Name',
  'ceaRegNo': 'CEA Reg. No.',
  'salesperson.businessName': 'Business Name',
  'salesperson.ceaRegNo': 'CEA Reg. No.',
  'nricName': 'Nric Name',
  'nricfin': 'NRIC / FIN',
  'avatar': 'Avatar',
  'joinDate': 'Join Date',
  'resignDate': 'Resign Date',
  'resignReason': 'Resign Reason',
  'companies': 'Companies',
  'companies.name': 'Name',
  'schemeType.name': 'Scheme Type',
  'user.roles': 'User Roles',
  'user.roles.name': 'Name',
  'parent.businessName': 'Manager Business Name',
  'parent.ceaRegNo': 'Manager CEA Reg. No.',
  'parent.parent.businessName': 'Next Level Manager Business Name',
  'parent.parent.ceaRegNo': 'Next Level Manager CEA Reg. No.',
  'effectiveDate': 'Effective Date',
  'managerEffectiveDate': 'Manager Effective Date',

  'transferRemark': 'Transfer Remark',
  'emplacementRemark': 'Emplacement Remark',
  'recruiter': 'Recruiter',
  'recruiter.businessName': 'Recruiter > Business Name',
  'recruiter.ceaRegNo': 'Recruiter > CEA Reg. No.',
  'recruiterDateFrom': 'Recruiter > Effective From',
  'recruiterDateTo': 'Recruiter > Effective To',

  'idType': 'ID Type',
  'idType.identification': 'ID Type',
  'dateOfBirth': 'Date Of Birth',
  'gender': 'Gender',
  'marital.name': 'Marital Status',
  'nationality': 'Nationality',
  'nationality.name': 'Nationality',
  'country': 'Country',
  'country.name': 'Country',
  'address.address': 'Address',
  'address.addressLine1': 'Address Line 1',
  'address.addressLine2': 'Address Line 2',
  'address.addressLine3': 'Address Line 3',
  'address.unit': 'Unit',
  'address.house': 'Block No',
  'address.floor': 'Floor',
  'address.street': 'Street',
  'address.district': 'District',
  'address.buildingName': 'Building Name',
  'postalCode': 'Postal Code',

  'phone.countryCode': 'Home Tel. > Country Code',
  'phone.phoneNumber': 'Home Tel. > Phone Number',
  'mobile1.countryCode': 'Mobile - 1 > Country Code',
  'mobile1.phoneNumber': 'Mobile - 1 > Phone Number',
  'mobile2.countryCode': 'Mobile - 2 > Country Code',
  'mobile2.phoneNumber': 'Mobile - 2 > Phone Number',
  'fax.countryCode': 'Fax > Country Code',
  'fax.phoneNumber': 'Fax > Phone Number',
  'email1': 'Email - 1',
  'email2': 'Email - 2',

  'bank': 'Bank',
  'bank.name': 'Bank',
  'bankAccountNo': 'Bank Account No',
  'bankUpdatedAt': 'Bank Information > Last Updated On',

  // career
  'leadership': 'Leadership',
  'leadership.designation': 'Leadership',
  'commissionScheme': 'Salesperson',
  'commissionScheme.designation': 'Salesperson',
  'leadershipDesignation': 'Enhanced Leadership Designation',
  'leadershipDesignation.name': 'Enhanced Leadership Designation',
  'appTypes': 'Agent Type',
  'appTypes.name': 'Name',

  //Education
  'qualification.name': 'Qualification',
  'discipline.name': 'Discipline',
  'startDate': 'Start Date',
  'endDate': 'End Date',
  'school': 'School',
  'achievement': 'Achievement',

  // additional info
  'informationType.name': 'Additional',


  //employment
  'periodFrom': 'Start Date',
  'periodTo': 'End Date',
  'companyName': 'Company Name',
  'employmentFrom': 'Employment From',
  'employmentTo': 'Employment To',
  'address': 'Address',
  'designation': 'Designation',
  'areaWork': 'Area of Work',
  'reasonLeft': 'Reason Left',
  //EmplacementEntity
  'manager.businessName': 'Manager Business Name',
  'manager.ceaRegNo': 'Manager CEA Reg. No.',
  'type': 'Type',
  'remarks': 'Remarks',
  'emplacement': 'Transfer / Emplacement History',
  'emplacement.salesperson.businessName': 'Business Name',
  'emplacement.salesperson.ceaRegNo': 'CEA Reg. No.',
  'emplacement.manager': 'Manager ',
  'emplacement.manager.businessName': 'Manager Business Name',
  'emplacement.manager.ceaRegNo': 'Manager CEA Reg. No.',
  'emplacement.effectiveDate': 'Effective Date',
  'emplacement.type': 'Type',
  'emplacement.remarks': 'Remarks',
};

export const fieldNameMapPersonalInfoVerication: { [key: string]: string } = {
  'id': 'ID',
  'salesperson.businessName': 'Business Name',
  'salesperson.ceaRegNo': 'CEA Reg. No.',
  'status': 'Status',
  'reviewed.name': 'Reviewer By > Business Name',
  'reviewed.username': 'Reviewer By > Login ID',
  'reviewedAt': 'Reviewed On',
  'reason': 'Reason',
  'name': 'Updated Information',
  'oldValue.value': 'Old Value',
  'oldValue.value.address': 'Old Value > Address',
  'oldValue.value.floor': 'Old Value > Floor',
  'oldValue.value.house': 'Old Value > Block No',
  'oldValue.value.street': 'Old Value > Street',
  'oldValue.value.unit': 'Old Value > Unit',
  'oldValue.value.postalCode': 'Old Value > Postal Code',
  'oldValue.value.district': 'Old Value > District',
  'oldValue.value.buildingName': 'Old Value > Building Name',
  'oldValue.value.addressLine1': 'Old Value > Address Line 1',
  'oldValue.value.addressLine2': 'Old Value > Address Line 2',
  'oldValue.value.addressLine3': 'Old Value > Address Line 3',
  'oldValue.value.countryCode': 'Old Value > Country Code',
  'oldValue.value.phoneNumber': 'Old Value > Phone Number',

  'newValue.value': 'New Value',
  'newValue.value.address': 'New Value > Address',
  'newValue.value.floor': 'New Value > Floor',
  'newValue.value.house': 'New Value > Block No',
  'newValue.value.street': 'New Value > Street',
  'newValue.value.unit': 'New Value > Unit',
  'newValue.value.postalCode': 'New Value > Postal Code',
  'newValue.value.district': 'New Value > District',
  'newValue.value.buildingName': 'New Value > Building Name',
  'newValue.value.addressLine1': 'New Value > Address Line 1',
  'newValue.value.addressLine2': 'New Value > Address Line 2',
  'newValue.value.addressLine3': 'New Value > Address Line 3',
  'newValue.value.countryCode': 'New Value > Country Code',
  'newValue.value.phoneNumber': 'New Value > Phone Number',

};

export const fieldNameMapHRSetup: { [key: string]: string } = {
  'id': 'ID',
  'salesperson.businessName': 'Business Name',
  'salesperson.ceaRegNo': 'CEA Reg. No.',
  'commissionType': 'HR Comm Scheme Type',
  'schemeType.name': 'Scheme Type',
  'type': 'Type',
  'code': 'Code',
  'name': 'Name',
  'designation': 'Designation',
  'autoApprove': 'Auto Approve',
  'status': 'Status',
  'isActive': 'Active',
  'level': 'Level',
  'sequence': 'Sequence',
  'directHeadcount': 'Direct Headcount',
  'totalHeadcount': 'Total Headcount',
  'requiredTeamMember': 'Team Member Designation',
  'requiredTeamMember.commissionScheme.code': 'Code',
  'requiredTeamMember.commissionScheme.designation': 'Designation',
  'requiredTeamMember.headcount': 'Direct Headcount',
  'requiredTeamMember.isActive': 'Active',

  'grossCommissionEarned.isActive': 'Gross Commission Earned',
  'grossCommissionEarned.commissionReceivedFrom': 'Commission Earned From',
  'grossCommissionEarned.commissionReceivedTo': 'Commission Earned To',
  'grossCommissionEarned.fixedEvaluationPeriod': 'Fixed Evaluation Period',
  'grossCommissionEarned.accumulatedPeriod': 'Accumulated Period',
  'grossCommissionEarned.resetAccumulatedPeriod': 'Reset Accumulated Period',
  'grossCommissionEarned.excludeOwnTransaction': 'Exclude Own Transaction',

  'requiredCommissionScheme': 'Required Salesperson Commission Scheme',
  'requiredCommissionScheme.commissionScheme.code': 'Code',
  'requiredCommissionScheme.commissionScheme.designation': 'Designation',
  'requiredCommissionScheme.isActive': 'Active',

  'minCommission': 'Commission Received From',
  'maxCommission': 'Commission Received To',

  'splitMatrices': 'Commission Scheme',
  'splitMatrices.tiers.0.percentage': 'Commission (%)',
  'splitMatrices.tiers.1.percentage': 'Tier 1 (%)',
  'splitMatrices.tiers.2.percentage': 'Tier 2 (%)',
  'splitMatrices.parties.0.percentage': 'Recruiter (%)',


  //'Multi-Tier Sharing
  'branchOutAmount': 'Branch-out Amount',
  'group1': 'Group 1',
  'maximumGroup1': 'Group 1 > Maximum Group Commission',
  'group1.sequence': 'Sequence',
  'group1.comm.code': 'Code',
  'group1.comm.designation': 'Designation',
  'group1.designation': 'Designation',
  'group1.profit': 'Profit Sharing',
  'group2': 'Group 2',
  'maximumGroup2': 'Group 2 > Maximum Group Commission',
  'group2.sequence': 'Sequence',
  'group2.comm.code': 'Code',
  'group2.comm.designation': 'Designation',
  'group2.designation': 'Designation',
  'group2.profit': 'Profit Sharing',

  'effectiveDate': 'Effective Date',
  'description': 'Description',
  'amount': 'Opening Amount',
  'paymentType': 'Payment Type',
  'company.name': 'Company',
  'startDate': 'Effective Date From',
  'endDate': 'Effective Date To',

};

export const RECORD_TYPES_HRM: Record<RecordTypesHrm, OptionDescription<RecordTypesHrm>> = {
  [RecordTypesHrm.SalespersonEntity]: {
    id: RecordTypesHrm.SalespersonEntity,
    value: RecordTypesHrm.SalespersonEntity,
    name: 'Agent Manager',
    viewValue: 'Agent Manager',
    fieldNameMap: fieldNameMapSalesperson,
    fieldsHide: [...generalFieldsHide],
    fieldsImage: ['avatar']
  },
  [RecordTypesHrm.CareerProgressionEntity]: {
    id: RecordTypesHrm.CareerProgressionEntity,
    value: RecordTypesHrm.CareerProgressionEntity,
    name: 'Career Progression',
    viewValue: 'Career Progression',
    fieldNameMap: fieldNameMapSalesperson,
    fieldsHide: [...generalFieldsHide, 'status', 'endDate'],
    fieldsAlign: [{ fieldName: 'appTypes', key: 'id' }] as IAuditTrailAlignField[]
  },
  [RecordTypesHrm.AdditionalEntity]: {
    id: RecordTypesHrm.AdditionalEntity,
    value: RecordTypesHrm.AdditionalEntity,
    name: 'Additional Information',
    viewValue: 'Additional Information',
    fieldNameMap: fieldNameMapSalesperson,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesHrm.EducationEntity]: {
    id: RecordTypesHrm.EducationEntity,
    value: RecordTypesHrm.EducationEntity,
    name: 'Education Records',
    viewValue: 'Education Records',
    fieldNameMap: fieldNameMapSalesperson,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesHrm.HistoryEntity]: {
    id: RecordTypesHrm.HistoryEntity,
    value: RecordTypesHrm.HistoryEntity,
    name: 'Employment History',
    viewValue: 'Employment History',
    fieldNameMap: fieldNameMapSalesperson,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesHrm.EmplacementEntity]: {
    id: RecordTypesHrm.EmplacementEntity,
    value: RecordTypesHrm.EmplacementEntity,
    name: 'Transfer / Emplacement History',
    viewValue: 'Transfer / Emplacement History',
    fieldNameMap: fieldNameMapSalesperson,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesHrm.DocumentEntity]: {
    id: RecordTypesHrm.DocumentEntity,
    value: RecordTypesHrm.DocumentEntity,
    name: 'Document',
    viewValue: 'Document',
    fieldNameMap: { ...fieldNameMapSalesperson, 'name': 'File Name', 'size': 'File Size' },
    fieldsHide: [...generalFieldsHide, 'url']
  },
  [RecordTypesHrm.CommissionSchemeEntity]: {
    id: RecordTypesHrm.CommissionSchemeEntity,
    value: RecordTypesHrm.CommissionSchemeEntity,
    name: 'HR Comm Scheme',
    viewValue: 'HR Comm Scheme',
    fieldNameMap: fieldNameMapHRSetup,
    fieldsHide: [...generalFieldsHide, 'level']
  },
  [RecordTypesHrm.ProfitSharingEntity]: {
    id: RecordTypesHrm.ProfitSharingEntity,
    value: RecordTypesHrm.ProfitSharingEntity,
    name: 'Multi-Tier Sharing',
    viewValue: 'Multi-Tier Sharing',
    fieldNameMap: fieldNameMapHRSetup,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesHrm.LeadershipDesignationEntity]: {
    id: RecordTypesHrm.LeadershipDesignationEntity,
    value: RecordTypesHrm.LeadershipDesignationEntity,
    name: 'Enhanced Leadership Designation',
    viewValue: 'Enhanced Leadership Designation',
    fieldNameMap: fieldNameMapHRSetup,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesHrm.SalespersonVerifyEntity]: {
    id: RecordTypesHrm.SalespersonVerifyEntity,
    value: RecordTypesHrm.SalespersonVerifyEntity,
    name: 'Personal Info Verification',
    viewValue: 'Personal Info Verification',
    fieldNameMap: fieldNameMapPersonalInfoVerication,
    fieldsHide: [...generalFieldsHide, 'type', 'oldValue.value.district', 'newValue.value.district']
  },
  [RecordTypesHrm.GCEEntity]: {
    id: RecordTypesHrm.GCEEntity,
    value: RecordTypesHrm.GCEEntity,
    name: 'GCE Opening Amount',
    viewValue: 'GCE Opening Amount',
    fieldNameMap: fieldNameMapHRSetup,
    fieldsHide: [...generalFieldsHide, 'paymentType', 'status']
  },
  [RecordTypesHrm.IR8AEntity]: {
    id: RecordTypesHrm.IR8AEntity,
    value: RecordTypesHrm.IR8AEntity,
    name: 'IR8A Opening Amount',
    viewValue: 'IR8A Opening Amount',
    fieldNameMap: fieldNameMapHRSetup,
    fieldsHide: [...generalFieldsHide, 'paymentType', 'status']
  },
};
